import { render, staticRenderFns } from "./modal-edit-volume.component.vue?vue&type=template&id=2223c9c4"
import script from "./modal-edit-volume.component.vue?vue&type=script&lang=js"
export * from "./modal-edit-volume.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports